import 'focus-visible';

/**
 * App
 * This starting point for this application.
 * @version 3.0.0
 * @exports App
 */
export default class App {
	constructor() {
		setTimeout(() => {
			this._initAudioPlayer();
			this._initVideoPlayer();
			this._initAccordion();
			this._initSlideshow();
			this._initStartpageStickykNavbar();
			this._initCarousel();
			this._initMobileMenu();
			this._initStickykNavbar();
			this._initExternalLinks();
			this._initCookieBotFallback();
		}, 10);
	}

	/**
	 * Function that initiates the accordion functionality.
	 * @private
	 */
	_initAccordion() {
		let els = document.querySelectorAll('[data-type="accordion-container"]');

		if (els.length > 0) {
			import(
				/* webpackChunkName: "accordion" */ './components/accordion/accordion'
			).then(Accordion => {
				for (let i = 0; i < els.length; i++) {
					let el = els[i];

					if (el.getAttribute('data-accordion-initiated') === null) {
						new Accordion.default(el);
						el.setAttribute('data-accordion-initiated', true);
					}
				}
			});
		}
	}
	/**
	 * Function that outputs Cookiebot fallback for blocked embeds.
	 * @private
	 */
	_initCookieBotFallback() {
		let els = document.querySelectorAll('iframe[data-cookieblock-src]');
		if (els.length > 0) {
			import(
				/* webpackChunkName: "cookiebot-embed-fallback" */ './components/cookiebot-fallback/cookiebot-fallback'
			).then(CookiebotEmbedFallback => {
				new CookiebotEmbedFallback.default().init();
			});
		}
	}

	/**
	 * Function that initiates the audio player functionality.
	 * @private
	 */
	_initAudioPlayer() {
		let els = document.querySelectorAll('[data-type="audio-player"]');

		if (els.length > 0) {
			import(
				/* webpackChunkName: "accordion" */ './components/audioPlayer/audio'
			).then(AudioPlayer => {
				for (let i = 0; i < els.length; i++) {
					let el = els[i];

					if (el.getAttribute('data-audio-player-initiated') === null) {
						new AudioPlayer.default(el);
						el.setAttribute('data-audio-player-initiated', true);
					}
				}
			});
		}
	}

	/**
	 * Function that initiates the Glide carousel functionality.
	 * @private
	 */
	_initSlideshow() {
		let els = document.querySelectorAll('[data-type="slideshow"]');
		if (els.length > 0) {
			import('components/slideshow/slideshow.js').then(Slideshow => {
				for (let i = 0; i < els.length; i++) {
					let el = els[i];
					if (el.getAttribute('slideshow-initiated') === null) {
						new Slideshow.default(el);
						el.setAttribute('slideshow-initiated', true);
					}
				}
			});
		}
	}
	/*
	 * Function that initiates the audio player functionality.
	 * @private
	 */
	_initVideoPlayer() {
		let els = document.querySelectorAll('[data-type="video-player"]');

		if (els.length > 0) {
			import(
				/* webpackChunkName: "accordion" */ './components/html5-video/video-player'
			).then(VideoPlayer => {
				for (let i = 0; i < els.length; i++) {
					let el = els[i];

					if (el.getAttribute('data-video-player-initiated') === null) {
						new VideoPlayer.default(el);
						el.setAttribute('data-video-player-initiated', true);
					}
				}
			});
		}
	}

	/*
	 * Function that initiates sticky navbar functionality.
	 * @private
	 */
	_initStartpageStickykNavbar() {
		let els = document.querySelectorAll(
			'[data-type="startpage-sticky-navbar"]'
		);

		if (els.length > 0) {
			import(
				/* webpackChunkName: "sticky-navbar" */ './components/startpage-sticky-navbar/startpage-sticky-navbar'
			).then(StartpageStickyNavbar => {
				for (let i = 0; i < els.length; i++) {
					let el = els[i];

					if (
						el.getAttribute('data-startpage-sticky-navbar-initiated') === null
					) {
						new StartpageStickyNavbar.default(el);
						el.setAttribute('data-startpage-sticky-navbar-initiated', true);
					}
				}
			});
		}
	}

	/*
	 * Function that initiates sticky navbar functionality.
	 * @private
	 */
	_initStickykNavbar() {
		let els = document.querySelectorAll('[data-type="sticky-navbar"]');

		if (els.length > 0) {
			import(
				/* webpackChunkName: "sticky-navbar" */ './components/sticky-navbar/sticky-navbar'
			).then(StickyNavbar => {
				for (let i = 0; i < els.length; i++) {
					let el = els[i];

					if (el.getAttribute('data-sticky-navbar-initiated') === null) {
						new StickyNavbar.default(el);
						el.setAttribute('data-sticky-navbar-initiated', true);
					}
				}
			});
		}
	}

	/*
	 * Function that initiates carousel functionality.
	 * @private
	 */
	_initCarousel() {
		let els = document.querySelectorAll('[data-type="carousel"]');

		if (els.length > 0) {
			import(
				/* webpackChunkName: "carousel" */ './components/carousel/carousel'
			).then(Carousel => {
				for (let i = 0; i < els.length; i++) {
					let el = els[i];

					if (el.getAttribute('data-carousel-initiated') === null) {
						new Carousel.default(el);
						el.setAttribute('data-carousel-initiated', true);
					}
				}
			});
		}
	}

	/*
	 * Function that initiates mobile menu functionality.
	/**
	 * Function that initiates the mobile menu functionality.
	 * @private
	 */
	_initMobileMenu() {
		let els = document.querySelectorAll('[data-type="mobile-menu"]');

		if (els.length > 0) {
			import(
				/* webpackChunkName: "mobile-menu" */ './components/mobile-menu/mobile-menu'
			).then(MobileMenu => {
				for (let i = 0; i < els.length; i++) {
					let el = els[i];

					if (el.getAttribute('data-mobile-menu-initiated') === null) {
						new MobileMenu.default(el);
						el.setAttribute('data-mobile-menu-initiated', true);
					}
				}
			});
		}
	}

	_initExternalLinks() {
		const els = document.querySelectorAll(
			'.richtext a[href^="http"], .richtext-footer a[href^="http"]'
		);

		els.forEach(el => {
			if (!el.href.includes(window.location.hostname)) {
				el.innerHTML +=
					'<span class="material-icons text-xl">open_in_new<div></div></span>';
			}
		});
	}
}
